/* eslint-disable */
import React, { useState, useEffect, useRef, useContext } from "react";
import axios from "axios";
import { Link, useNavigate } from "react-router-dom";
import { cl } from './components/functions';
import './headerbase.css';


var gGlobal = require('./components/globalvar.js');
var pjson = require('../package.json');
global.gVersion = pjson.version


/* jQuery.event.special.touchstart = {
    setup: function (_, ns, handle) {
        this.addEventListener("touchstart", handle, { passive: !ns.includes("noPreventDefault") });
    }
}; */

const TOKEN_KEY = "KEY_APP_BGG";
global.gIdUser = 0;

function Gerador(params) {



  async function getVersion() {
    var bodyFormData = new FormData();
    bodyFormData.set('apikey', '9QV045NV$Vq3cVBNh@$MG@$OJG48ugyf987nsmIlHoEs');
    const urlfull = 'https://api.youevolution.com.br/listaVersion.php';
    const response = await axios({
      method: 'post',
      url: urlfull,
      data: bodyFormData,
      config: { headers: { 'Content-Type': 'multipart/form-data' } }
    })
    //cl("response",response['data'][0].ver);
    global.gNewVersion = response['data'][0].ver;
    if ((global.gVersion) && (global.gNewVersion) && (global.gVersion !== global.gNewVersion) && (global.showVersion !== 1)) {
      let msg = "Nova Atualização disponível do sistema, versão " + global.gNewVersion + " , saia do sistema e atualize seu navegador agora ou reinstale o APP!";
      window.alert(msg);
      global.showVersion = 1;
      //window.location.href = "/login";
    }
  };

  getVersion();
  //cl("clglobal.gVersion",global.gVersion);
  //cl("clglobal.gNewVersion",global.gNewVersion);




  let whost = window.location.hostname.toString();

  let whref = 'nodev';

  //cl("whost",whost)

  //let url = 'https://app.riluk.com.br/nodev';
  let url = whref;

  if (whost !== 'localhost') {

    //disableDevtool({ url: url });
  }

  //console.log("habilitar disableDevtool");
  //cl("window.location.href",window.location.href)
  //cl("window.location.hostname",window.location.hostname)
  //cl("window.location.pathname",window.location.pathname)
  function b64DecodeUnicode(str) {
    return decodeURIComponent(Array.prototype.map.call(atob(str), function (c) {
      return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)
    }).join(''))
  }

  const token = sessionStorage.getItem(TOKEN_KEY);//sessionStorage.getItem(TOKEN_KEY);
  //cl("Tokennn2", token)
  //if (sessionStorage.getItem(TOKEN_KEY) == "null") {
  if (!token) {
    sessionStorage.removeItem(TOKEN_KEY); //sessionStorage.removeItem(TOKEN_KEY);
    window.open("/logout", "_self");
  } else {
    //cl("Tokennn2length", token)
    const base64Url = token.split('.')[1];
    //cl("base",base64Url);
    const decodedValue = JSON.parse(b64DecodeUnicode(base64Url));
    //console.log("decode",decodedValue);
    const novoObj = decodedValue;
    //cl("novoObj",novoObj);
    global.gNome = novoObj[0].nome;
    global.gTipoUser = novoObj[0].tipo;
    global.gDoc = novoObj[0].doc;
    global.gCond = novoObj[0].cod;
    global.gNomecond = novoObj[0].nomecond;
    global.gEmail = novoObj[0].email;
    global.gIdUser = novoObj[0].id;
    global.gIDProf = novoObj[0].idprof;
    global.gIdCliFromUsu = novoObj[0].idCliFromUsu;
    global.gNewVersion = novoObj[0].ver;
    global.gAprovado = novoObj[0].aprovado;
    global.gEnd = novoObj[0].end;
    global.gNum = novoObj[0].num;
    global.gCompl = novoObj[0].compl;
    global.gRef = novoObj[0].ref;    
    //cl("gIDProf",global.gIDProf)
    //cl("gIdUser",global.gIdUser)
    //cl("gNome",global.gNome);
    //cl("gTipoUser header",global.gTipoUser);
    //cl("gEmail",global.gEmail);
    //global.gLinkBase = "http://adminrl.dyndns.org:8085";
    //cl("gDoc",global.gDoc);
    //cl("gCond",global.gCond);
    global.gListCond = '';
    global.gaListCond = [];
    for (var i in novoObj) {
      if (i > 0) {
        global.gListCond = global.gListCond + ',';
      }
      global.gListCond = global.gListCond + novoObj[i].cod;

      global.gaListCond[novoObj[i].cod] =
      {
        "nome": novoObj[i].nomecond,
        "bl": novoObj[i].bloco,
        "unid": novoObj[i].unidade
      };

    }

    //cl("gListCond for ",global.gListCond);

    //cl("gaListCond for ",global.gaListCond);

    //console.log(nome);
    //cl("gAprovado",global.gAprovado)
    
    if(global.gAprovado === 'N') {
      window.alert("Seu cadastro esta aguardando a liberação da Administração, volte depois!");
      window.open("/logout", "_self");
      return (
          <div></div>)
      }

  };

  return (
    <div className="divheader">
      <title>Universo YOU - APP</title>
      {/* Tell the browser to be responsive to screen width */}
          <a className="alogohome" href="/">
            <img src="dist/img/icon-192x192.png" alt="You Evolution" className="logohome" style={{ opacity: '.8' }} />
          </a>
            <ul className="mheaderUl">
              <li className="mheaderUlLi"><a className="mheaderUlLiA" href="/">Inicial</a></li>
              <li className="mheaderUlLi"><a className="mheaderUlLiA" href="/directorio-en-galera">Deiretório AI</a></li>
              <li className="mheaderUlLi"><a className="mheaderUlLiA" href="/todas-las-categorias">Categorias</a></li>
              <li className="mheaderUlLi"><a className="mheaderUlLiA" href="/blog-y-noticias">Cadastre-se</a></li>
              <li className="mheaderUlLi"><a className="mheaderUlLiA" href="/contacto">Contato</a></li>
            </ul>
    </div>
  )

}
export default Gerador





